import React, { useEffect } from 'react';
import config from 'client/shared/config';
import { NavLink } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

const StayTuned = () => {
    return (
        <div className="hero-banner" style={{background: `black`}}>
            <div className="hero-blurb-container">
                <div className="hero-title">You could be featured next!</div>
                <div className="hero-detail-text">
                    <p>Stay tuned.</p>
                </div>
            </div>
        </div>
    );
};

const HeroArtist = ({ artist }) => {
    const { featuredBio, bannerImage, name, id } = artist;
    return (
        <div className="hero-banner" style={{background: `url('${config.paths.bannerImgBasePath}/${bannerImage}')`}}>
            {artist.isExclusive && (
                <div className="mzd-exclusive-hero-banner">
                    Muzado Exclusive Artist
                </div>
            )}
            <div className="hero-blurb-container">
                <div className="hero-title" data-ta="hero-artist-name">{name}</div>
                <div className="hero-detail-text">
                    {featuredBio}
                </div>
                <NavLink to={ `/artist/${id}/tracks` }>
                    <button
                        data-ta="hero-go-to-artist-button"
                        className="add-button button margin-top-1"
                    >
                        Go To Artist
                    </button>
                </NavLink>
            </div>
        </div>
    );
};

const HomepageHero = inject('membersBFFStore')(observer(({ membersBFFStore }) => {
    useEffect(() => {
        membersBFFStore.fetchHeroArtist();
    }, [membersBFFStore]);

    return (
        <>
            {!membersBFFStore.heroArtist ? <StayTuned /> : <HeroArtist artist={membersBFFStore.heroArtist} />}
        </>
    );
}));

export default HomepageHero;